export const PEDIDO_NOVO = 'ABERTO';
export const PEDIDO_LIDO = 'LIDO';
export const PEDIDO_CANCELADO = 'CANCELADO';

export const COMANDA_ABERTA = 'ABERTA';
export const COMANDA_FECHADA = 'FECHADA';

export const TIPO_DESCONTO_VALOR = 'VALOR';
export const TIPO_DESCONTO_PORCENTAGEM = 'PORCENTAGEM';

export const TIPO_PAGAMENTO_CARTAO = 'CARTAO';
export const TIPO_PAGAMENTO_DINHEIRO = 'DINHEIRO';

export const TIPOS_PAGAMENTO = [
  { id: TIPO_PAGAMENTO_DINHEIRO, label: 'Dinheiro' },
  { id: TIPO_PAGAMENTO_CARTAO, label: 'Cartão' }
];

export const TIPO_FILTRO_PAGAMENTO_TODOS = 'TODOS';
export const TIPO_FILTRO_PAGAMENTO_PAGOS = 'PAGOS / PARCIALMENTE PAGOS';
export const TIPO_FILTRO_PAGAMENTO_NAO_PAGOS = 'NÃO PAGOS';

export const FILTROS_PAGAMENTO = [
  TIPO_FILTRO_PAGAMENTO_TODOS,
  TIPO_FILTRO_PAGAMENTO_PAGOS,
  TIPO_FILTRO_PAGAMENTO_NAO_PAGOS
];


export const APP_NAME = 'zerograu'
export const SERVER_BASE = 'https://api.cardapp.in'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=br.com.zerograu'
export const TOKEN_GOOGLE_WEB = '128051723151-o3220csj33qv978seb63926i6v3d1gc6.apps.googleusercontent.com'
export const TOKEN_GOOGLE_ANDROID = '128051723151-ug3opsdjnpjj73trhr5c0j1k8qcm55bp.apps.googleusercontent.com'
export const SERVER_URL = `${SERVER_BASE}/${APP_NAME}`;
export const APP_URL = `https://cardapp.in/${APP_NAME}`;

export const NIVEL_ADMIN = 9;


